import TodoList from "./src";
import type { App } from "vue";

TodoList.install = function (Vue: App): void {
  console.info("TodoList----install----");
  Vue.component(TodoList.name, TodoList);
};

export default TodoList;
